import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { useDispatch, useSelector } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { correspondingMatrixPeriods } from '../../../constants/variables';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const CorrespondingMatrixFiltersComponent = () => {
    const { correspondingMatrixPeriod } = useSelector(({ mapFilters }) => mapFilters);
    const dispatch = useDispatch();
    const handleChange = e => {
        dispatch(onChangeMapFilters('correspondingMatrixPeriod', e.target.value));
    };

    return (
        <div>
            <div className={styles.legHead}>{t`Матрица корреспонденций`}:</div>

            <StandardRadioGroup
                value={correspondingMatrixPeriod}
                onChange={handleChange}
            >
                {correspondingMatrixPeriods.map(period => (
                    <FormControlLabel
                        key={period.value}
                        control={
                            <Radio
                                checked={correspondingMatrixPeriod === period.value}
                                onChange={handleChange}
                                value={period.value}
                                size='small'
                            />
                        }
                        label={i18n._(period.label)}
                        labelPlacement='end'
                    />
                ))}
            </StandardRadioGroup>
        </div>
    );
};

export const CorrespondingMatrixFilters = withDisplayedLayersCheck(
    CorrespondingMatrixFiltersComponent,
    'deck:operation_areas_corresponding_matrix'
);
